module.exports = __webpack_public_path__ + "img/about-main-mob.0ea6e118.jpg";